import { ReactComponent as Mastercard } from 'assets/img/mastercard.svg'
import { ReactComponent as ApplePay } from 'assets/img/apple-pay.svg'
import { ReactComponent as Visa } from 'assets/img/visa.svg'
import przelewy24_raty from 'assets/img/przelewy24_raty.png'
import { ReactComponent as GPay } from 'assets/GPay.svg'
import przelewy24 from 'assets/img/przelewy24.png'
import autopay from 'assets/autopay.svg'
import payu from 'assets/payu-dark.svg'
import viva from 'assets/img/viva.svg'
import blik from 'assets/blik.png'

export const getPaymentIcon = (payment) => {
  switch (true) {
    case payment.key === 'gpay':
      return <GPay />

    case (payment.key === 'applepay'):
      return <ApplePay />

    case payment.key === 'saved_method':
      return payment.savedMethod?.kind === 'blik_alias'
        ? <img
          alt='blik'
          src={blik}
        />
        : payment.savedMethod?.cardIssuer === 'Visa'
          ? <Visa />
          : payment.savedMethod?.cardIssuer === 'Mastercard'
            ? <Mastercard />
            : undefined

    case payment.key === 'blik':
      return <img
        alt='blik'
        src={blik}
      />

    case payment.key === 'credit':
      return <img
        alt='raty'
        src={przelewy24_raty}
      />

    case payment.key === 'bank_transfer':
      return 'bank'

    case (payment.key === 'online' && payment.paymentOperator === 'AUTOPAY'):
      return <img
        alt='autopay'
        src={autopay}
      />

    case (payment.key === 'online' && payment.paymentOperator === 'PRZELEWY24'):
      return <img
        alt='przelewy24'
        src={przelewy24}
      />

    case (payment.key === 'online' && payment.paymentOperator === 'PAYU'):
      return <img
        alt='payu'
        src={payu}
      />

    case (payment.key === 'online' && payment.paymentOperator === 'VIVAWALLET'):
      return <img
        alt='viva'
        src={viva}
      />

    default: return undefined
  }
}